/**
 * Rupees in words, for the invoice.
 *
 * Indian numbering, not international: after "thousand" comes "lakh" (100,000)
 * and then "crore" (10,000,000). 1,234,567 is "twelve lakh thirty four thousand
 * five hundred sixty seven", never "one million two hundred…".
 */
const ONES = [
  '', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
  'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen',
];
const TENS = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

/** 0–99. */
function underHundred(n) {
  if (n < 20) return ONES[n];
  const tens = TENS[Math.floor(n / 10)];
  const ones = ONES[n % 10];
  return ones ? `${tens} ${ones}` : tens;
}

/** 0–999. */
function underThousand(n) {
  const hundreds = Math.floor(n / 100);
  const rest = n % 100;
  if (!hundreds) return underHundred(rest);
  const head = `${ONES[hundreds]} hundred`;
  return rest ? `${head} ${underHundred(rest)}` : head;
}

function whole(n) {
  if (n === 0) return 'zero';

  const parts = [];
  const crore = Math.floor(n / 10000000);
  const lakh = Math.floor((n % 10000000) / 100000);
  const thousand = Math.floor((n % 100000) / 1000);
  const rest = n % 1000;

  if (crore) parts.push(`${whole(crore)} crore`);
  if (lakh) parts.push(`${underThousand(lakh)} lakh`);
  if (thousand) parts.push(`${underThousand(thousand)} thousand`);
  if (rest) parts.push(underThousand(rest));

  return parts.join(' ');
}

const titleCase = (text) => text.charAt(0).toUpperCase() + text.slice(1);

/**
 * `amountInWords(1234.50)` → "Rupees one thousand two hundred thirty four and
 * fifty paise only". Paise are rounded to two places, as on the invoice.
 */
export function amountInWords(amount) {
  const value = Number(amount);
  if (!Number.isFinite(value)) return '';

  const negative = value < 0;
  // Round the whole thing once, or 0.999 becomes "zero rupees and 100 paise".
  const totalPaise = Math.round(Math.abs(value) * 100);
  const rupees = Math.floor(totalPaise / 100);
  const paise = totalPaise % 100;

  const parts = [`rupees ${whole(rupees)}`];
  if (paise) parts.push(`and ${underHundred(paise)} paise`);
  parts.push('only');

  return titleCase(`${negative ? 'minus ' : ''}${parts.join(' ')}`);
}

export default amountInWords;
